import { saveAs } from "file-saver";
const baseUrl = "/api/Clearing/";

export function getClearings(org, year) {
  return fetch(baseUrl + org + "?year=" + year, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getClearing(clearingId) {
  return fetch(baseUrl + "Id/" + clearingId, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export function getClearingsbyId(type, id, compId) {
  return fetch(baseUrl + type + "/" + id + "?CompId=" + compId, {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
        //return await JSON.parse(response.text());
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

export async function getYears(org) {
  return fetch("/api/Types/" + org + "/Vintages", {
    method: "GET",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.json();
      } else {
        return false;
        //return await JSON.parse(response.text());
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//Deletes Clearing
export async function deleteClearing(clearingId) {
  return fetch(baseUrl + "Delete/" + clearingId, {
    method: "DELETE",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.status === 400) {
        // So, a server-side validation error occurred.
        // Server side validation returns a string error message, so parse as text instead of json.
        const error = await response.text();
        throw new Error(error);
      } else if (response.ok) {
        return response;
      } else {
        return false;
        //return await JSON.parse(response.text());
        //throw new Error("Network response was not ok.");
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
      throw error;
    });
}

//New prize ownerhsip history for prizeId
export function newClearing(org, year, month) {
  return fetch(baseUrl + "NewClearing/" + org + "/" + year + "-" + month, {
    method: "POST",
    headers: new Headers({
      Authorization:
        "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
      "Content-Type": "application/json",
    }),
  })
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        return response.text();
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}

//Download excel for clearing
export function getExcelFile(type, clearingId, compId, download) {
  return fetch(
    baseUrl +
      type +
      "/" +
      clearingId +
      "?CompId=" +
      compId +
      "&export=" +
      download,
    {
      method: "GET",
      headers: new Headers({
        Authorization:
          "Bearer " + JSON.parse(sessionStorage.getItem("token")).token,
        "Content-Type": "Content-Type/attachment",
      }),
      responseType: "blob",
    }
  )
    .then(async (response) => {
      if (response.status === 401) {
        sessionStorage.removeItem("token");
        return undefined;
      } else if (response.ok) {
        const filename = response.headers
          .get("content-disposition")
          .split(";")
          .find((n) => n.includes("filename="))
          .replace("filename=", "")
          .trim()
          .replace(/^"(.*)"$/, "$1");
        const blob = await response.blob();
        saveAs(blob, filename);
      } else {
        return false;
      }
    })
    .catch((error) => {
      console.error("API call failed. " + error);
    });
}
